/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_to_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Pokračovat`
};

const da_to_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Fortsæt`
};

const de_to_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Weiter`
};

const en_to_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Continue`
};

const es_to_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Continuar`
};

const fr_to_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Continuer`
};

const hu_to_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Folytatás`
};

const it_to_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Continua`
};

const nl_to_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Doorgaan`
};

const pl_to_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Kontynuuj`
};

const pt_to_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Continuar`
};

const sv_to_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Fortsätt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const to_continue = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.to_continue(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("to_continue", locale)
	if (locale === "cs") return cs_to_continue(inputs)
	if (locale === "da") return da_to_continue(inputs)
	if (locale === "de") return de_to_continue(inputs)
	if (locale === "en") return en_to_continue(inputs)
	if (locale === "es") return es_to_continue(inputs)
	if (locale === "fr") return fr_to_continue(inputs)
	if (locale === "hu") return hu_to_continue(inputs)
	if (locale === "it") return it_to_continue(inputs)
	if (locale === "nl") return nl_to_continue(inputs)
	if (locale === "pl") return pl_to_continue(inputs)
	if (locale === "pt") return pt_to_continue(inputs)
	return sv_to_continue(inputs)
};